/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState } from "react";
import {
  AboutDiv,
  AttachmentInformationDiv,
  InformationHeading,
  MainContainer,
  ProfileDiv,
} from "../Profile/Profile.style";

import AttachmentIcon from "@mui/icons-material/Attachment";
import { useSelector } from "react-redux";
import girl from "../../Images/girl.png";
import profile from "../../Images/profile.png";
import {
  InputContainer,
  InputLevel,
  PdfDiv,
  PidDiv,
  RegHeadingDiv,
  RegisterDiv,
} from "./Volunteer.style";

import moment from "moment/moment";
// import { BsFillPrinterFill } from "react-icons/bs";
// import PdfVolProfile from "./PdfVolProfile";
import AttachmentDownloadButton from "../Others/AttachmentDownloadButton";

const VolunteerAttachmentProfile = () => {
  const volunteerData = useSelector((state) => state.Modal.val);

  const [inputs, setInputs] = useState([]);
  const [history, setHistory] = useState([]);

  const pid = volunteerData.vol_id !== "";
  const femaleStatus = volunteerData?.sex;

  const availability = volunteerData?.availability;
  const previous_clinic_trial = volunteerData.previous_clinic_trial;

  useEffect(() => {
    console.log("i am voulenteer data from storage", volunteerData);
  }, []);

  useEffect(() => {}, [inputs]);

  return (
    <>
      <ProfileDiv>
        {/* //! pdf download button */}
        {/* <div style={{ display: "flex", justifyContent: "end" }}>
          <Button
            size="small"
            className="entries"
            onClick={() => window.print()}
            variant="outlined"
            startIcon={<BsFillPrinterFill />}
          >
            PDF Download
          </Button>
        </div> */}

        {/* //! top part pid num, date of registration, profile image */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "4fr 2fr",
            gap: "1rem",
          }}
        >
          <RegHeadingDiv
            style={{
              margin: "2rem 1rem 1rem 1rem",
            }}
          >
            <div>
              {/* //! pid number */}
              {pid && (
                <InputContainer style={{ marginBottom: "1rem" }}>
                  <InputLevel
                    style={{
                      backgroundColor: "#3490DC",
                      borderColor: "#3490DC",
                    }}
                  >
                    PID Number
                  </InputLevel>
                  <PidDiv>{volunteerData?.vol_id}</PidDiv>
                </InputContainer>
              )}

              {/* //! date of registration */}
              <InputContainer>
                <InputLevel>Date of Registration</InputLevel>
                <RegisterDiv>
                  {moment(volunteerData.date_of_registration).format(
                    "DD MMM YYYY"
                  )}
                </RegisterDiv>
              </InputContainer>
            </div>
          </RegHeadingDiv>

          {/* default image for female */}
          {femaleStatus === "Female" && (
            <div style={{ marginLeft: "1rem", marginTop: "1rem" }}>
              <img
                style={{
                  height: "125px",
                  wight: "auto",
                }}
                src={volunteerData.voluntary_image || girl}
                alt=""
              />
            </div>
          )}

          {/* default image for male */}
          {femaleStatus === "Male" && (
            <div style={{ marginLeft: "1rem", marginTop: "1rem" }}>
              <img
                style={{
                  height: "125px",
                  wight: "auto",
                }}
                src={volunteerData.voluntary_image || profile}
                alt=""
              />
            </div>
          )}

          {/* default image for others */}
          {femaleStatus === "Others" && (
            <div style={{ marginLeft: "1rem", marginTop: "1rem" }}>
              <img
                style={{
                  height: "125px",
                  wight: "auto",
                }}
                src={volunteerData.voluntary_image || profile}
                alt=""
              />
            </div>
          )}
        </div>

        {/* //! attachments */}
        <AboutDiv className="entries" style={{ margin: " 1rem" }}>
          <AttachmentIcon></AttachmentIcon>
          <span
            style={{
              color: "#20215c",
              fontWeight: "600",
              letterSpacing: "0.4px",
              lineHeight: "32px",
              margin: "0px 0px 0px 8px",
            }}
          >
            Attachment
          </span>
        </AboutDiv>
        <MainContainer style={{ gridTemplateColumns: "1fr" }}>
          {/*//!  vlounteer profile image  */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              alignContent: "center",
              gap: "10px",
            }}
          >
            <div style={{ minWidth: "220px" }}>
              <InformationHeading>Volunteer Image:</InformationHeading>
            </div>
            {/* download button */}
            {volunteerData?.voluntary_image ? (
              <AttachmentDownloadButton
                downloadLink={volunteerData?.voluntary_image}
              />
            ) : (
              <AttachmentInformationDiv>
                <p>No document present</p>
              </AttachmentInformationDiv>
            )}
          </div>

          {/*//!  vlounteer nid card  */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              alignContent: "center",
              gap: "10px",
            }}
          >
            <div style={{ minWidth: "220px" }}>
              <InformationHeading>Volunteer NID Card:</InformationHeading>
            </div>
            {/* download button */}
            {volunteerData?.voluntary_nid_image ? (
              <AttachmentDownloadButton
                downloadLink={volunteerData?.voluntary_nid_image}
              />
            ) : (
              <AttachmentInformationDiv>
                <p>No document present</p>
              </AttachmentInformationDiv>
            )}
          </div>

          {/*//! father husband nid card  */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <div style={{ minWidth: "220px" }}>
              <InformationHeading>
                Father / Husband NID Card:
              </InformationHeading>
            </div>
            {/* download button */}
            {volunteerData?.fathr_or_husb_nid_image ? (
              <AttachmentDownloadButton
                downloadLink={volunteerData?.fathr_or_husb_nid_image}
              />
            ) : (
              <AttachmentInformationDiv>
                <p>No document present</p>
              </AttachmentInformationDiv>
            )}
          </div>

          {/*//!covid-19 card  */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <div style={{ minWidth: "220px" }}>
              <InformationHeading>COVID-19 vaccine Card:</InformationHeading>
            </div>

            {/* download button */}
            {volunteerData?.covid_image ? (
              <AttachmentDownloadButton
                downloadLink={volunteerData?.covid_image}
              />
            ) : (
              <AttachmentInformationDiv>
                <p>No document present</p>
              </AttachmentInformationDiv>
            )}
          </div>
        </MainContainer>
      </ProfileDiv>
      {/* <PDFViewer>
      <PdfVolProfile volunteerData={volunteerData} history={history} />
  </PDFViewer> */}
      {/* <PdfDiv>
        <PdfVolProfile volunteerData={volunteerData} history={history} />
      </PdfDiv> */}
    </>
  );
};

export default VolunteerAttachmentProfile;
